import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { firestorePlugin } from 'vuefire'

import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/performance'
import 'firebase/analytics'
import 'firebase/remote-config'

import LoadingBar from '@/components/LoadingBar.vue'
import Loading from '@/components/Loading.vue'

//
import {CardPlugin, ModalPlugin, LayoutPlugin, ProgressPlugin, ButtonPlugin, OverlayPlugin, LinkPlugin} from 'bootstrap-vue'
[CardPlugin, ModalPlugin, LayoutPlugin, ProgressPlugin, ButtonPlugin, OverlayPlugin, LinkPlugin].forEach(comp => {
  Vue.use(comp)
})

// import { BootstrapVue } from 'bootstrap-vue'
import _config from '@/config.js'

var __config = _config[process.env.VUE_APP_CONFIG || 'development-local']

Vue.use(firestorePlugin)
// Vue.use(BootstrapVue)
Vue.component('Loading', Loading)
Vue.component('LoadingBar', LoadingBar)

import Analytics from 'analytics'
// import hubspot from '@analytics/hubspot'
// import fullstory from '@analytics/fullstory'
// import segment from '@analytics/segment'
// import googleAnalytics from '@analytics/google-analytics'
// import mixpanelPlugin from '@analytics/mixpanel'

// let plugins = [googleAnalytics({trackingId: __config.firebase_config.measurementId})]
// if (__config.fullstory.org_id) {
//   plugins.push(fullstory({org: __config.fullstory.org_id}))
// }
// if (__config.hubspot.site_id) {
//   plugins.push(hubspot({portalId: __config.hubspot.site_id}))
// }
// if (__config.segment.write_key) {
//   plugins.push(segment({writeKey: __config.segment.write_key}))
// }
// if (__config.mixpanel.token) {
//   plugins.push(mixpanelPlugin({token: __config.mixpanel.token}))
// }

export const analytics = Analytics({
  app: `doli-${process.env.VUE_APP_CONFIG}`,
  version: 100,
  // plugins: plugins,
  debug: false
})

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import '@/assets/custom.scss'

Vue.config.productionTip = false

firebase.initializeApp(__config.firebase_config)

let _remote_config = firebase.remoteConfig()
if (process.env.VUE_APP_CONFIG === 'local' || process.env.VUE_APP_CONFIG === 'development' || process.env.VUE_APP_CONFIG === 'development-local') {
  _remote_config.settings.minimumFetchIntervalMillis = 60 * 1000;
} else {
  _remote_config.settings.minimumFetchIntervalMillis = 60 * 60 * 1000; // once an hour
}

_remote_config.defaultConfig = {

}

_remote_config.fetchAndActivate()

export const db = firebase.firestore()
export const perf = firebase.performance()
export const remote_config = _remote_config

// export const analytics = firebase.analytics()
export const config = _config[process.env.VUE_APP_CONFIG || 'development-local']

if (process.env.VUE_APP_CONFIG === 'local') {
  console.log('** LOCAL **')
  db.useEmulator('localhost', 5001)
}

if (process.env.VUE_APP_CONFIG === 'development') {
  console.log('** DEVELOPMENT **')
}

if (process.env.VUE_APP_CONFIG === 'development-local') {
  console.log('** DEVELOPMENT LOCAL **')
}

router.beforeEach((to, from, next) => {
  next()
  analytics.page()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
